import script from "./ClassifyPart.vue?vue&type=script&lang=ts&setup=true"
export * from "./ClassifyPart.vue?vue&type=script&lang=ts&setup=true"

import "./ClassifyPart.vue?vue&type=style&index=0&id=dec5ce42&lang=less&scoped=true"

import exportComponent from "D:\\myWork\\番顺茶叶官网\\panshunwebsite\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dec5ce42"]])

export default __exports__